'use client';

import { motion, AnimatePresence } from 'framer-motion';

import { PropsWithChildren } from 'react';

const ContentTransition = ({ children }: PropsWithChildren) => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 1 }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default ContentTransition;
